import { Link } from "react-router-dom";
import { FileCheck2, Route, Scale } from "lucide-react";
import { CertificatePreview } from "@/components/CertificatePreview";
import { SectionHead } from "@/components/home/CategoriesGrid";

const POINTS = [
  { icon: Route, t: "Trazabilidad de origen a destino", d: "Cada lote registra generador, retiro, pesaje y valorizador final." },
  { icon: Scale, t: "Toneladas de CO₂ eq. mitigadas", d: "Cálculo por material con factores de emisión por tipo de scrap." },
  { icon: FileCheck2, t: "Listo para reportes ESG y Ley REP", d: "Certificados descargables para auditorías y memorias de sostenibilidad." },
];

export const EsgSection = () => (
  <section className="bg-[#0d1b1e] relative overflow-hidden grain" data-testid="esg-section">
    <div className="absolute inset-0 grid-mask opacity-60" />
    <div className="relative max-w-[1400px] mx-auto px-5 lg:px-8 py-24 grid lg:grid-cols-2 gap-16 items-center">
      <div>
        <SectionHead light eyebrow="ESG & Trazabilidad" title="Cada tonelada valorizada, certificada" text="Las empresas generadoras obtienen un Certificado de Valorización y Mitigación CO₂ por cada lote cerrado." />
        <ul className="space-y-6">
          {POINTS.map((p) => (
            <li key={p.t} className="flex gap-4">
              <span className="w-11 h-11 rounded-xl bg-[#00f2a1]/10 border border-[#00f2a1]/30 flex items-center justify-center shrink-0"><p.icon className="w-5 h-5 text-[#00f2a1]" /></span>
              <div><p className="font-semibold text-white">{p.t}</p><p className="text-sm text-slate-400 mt-1">{p.d}</p></div>
            </li>
          ))}
        </ul>
        <Link to="/calculadora" data-testid="esg-cta-calculator" className="mt-10 inline-flex h-12 items-center px-7 rounded-full bg-[#00f2a1] text-[#05130e] font-semibold hover:bg-[#00d890] hover:shadow-[0_0_22px_rgba(0,242,161,0.45)] transition-[background-color,box-shadow] duration-300">
          Calcular mi impacto
        </Link>
      </div>
      <div className="max-w-md w-full mx-auto lg:ml-auto"><CertificatePreview /></div>
    </div>
  </section>
);
